import api from '@/plugins/api'
import { technicalControl as endpoint } from '@/configs/endpoints'
import requestValidation from '@/configs/requestValidation'

const store = 'statementTechnicalControl'

export default {
  state: () => ({
    statements: {},
    clientStatements: {},
    clientStatement: {},
    statement: {},
    isLoad: false
  }),
  actions: {
    async getTechControlStatements (context, filter) {
      context.commit('SET_DATA', { store, state: 'isLoad', data: true })
      const params = new URLSearchParams()
      for (let field in filter) {
        filter[field] && params.append(field, filter[field])
      }
      const response = await api.get(`${ endpoint.statement }?${ params }`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'statements', data: response.data })
      }
      context.commit('SET_DATA', { store, state: 'isLoad', data: false })
    },
    async getClientTechControlStatements (context, filter) {
      context.commit('SET_DATA', { store, state: 'isLoad', data: true })
      const params = new URLSearchParams()
      for (let field in filter) {
        filter[field] && params.append(field, filter[field])
      }
      const response = await api.get(`${ endpoint.clientStatement }?${ params }`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'clientStatements', data: response.data })
      }
      context.commit('SET_DATA', { store, state: 'isLoad', data: false })
    },
    async getTechControlStatement (context, id) {
      const response = await api.get(`${ endpoint.statement }${ id }/`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'statement', data: response.data })
        return response.data
      }
      return false
    },
    async getClientTechControlStatement (context, id) {
      const response = await api.get(`${ endpoint.clientStatement }${ id }/`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'clientStatement', data: response.data })
        return response.data
      }
      return false
    },
    async updateTechControlClientStatement (context, data) {
      const { id, ...body } = data
      const response = await api.patch(`${ endpoint.clientStatement }${ id }/`, { body })
      console.log(response)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'clientStatement', data: response.data })
        return response.data
      }
      return false
    },
    async setDecisionForTechControlStatement (context, body) {
      const response = await api.patch(endpoint.statementChange(body.id), { body: body.payload })
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getTechControlStatement', body.id)
      }
      return isResult
    },
    async setTechControlStatement (context, body) {
      const response = await api.post(endpoint.statement, { body: body })
      if (await requestValidation(response)) return response.data.id
      return false
    },
    async setMediaTechControl (context, data) {
      return Promise.all(data.body.map(async item => {
        const body = new FormData()
        body.append('type_file', item.type)
        
        item.files.forEach(file => {
          body.append('files', file)
        })
        return await api.post(endpoint.media(data.id), { body: body })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    async setClientSignatureOnTechControl (context, data) {
      const body = new FormData()
      body.append('client_watermark', data.signatureFile)
      
      const response = await api.post(endpoint.clientSignature(data.id), { body: body })
      const isResult = await requestValidation(response)
      if (isResult) await context.dispatch('getTechControlStatement', data.id)
      return isResult
    },
    async getAgreementTechnicalControlPDF (context, id) {
      const response = await api.get(endpoint.agreement(id))
      if (await requestValidation(response)) {
        return response.data.url
      }
      return false
    },
    async setTechControlStatementSign (context, id) {
      const response = await api.post(endpoint.statementSign, { body: { document: id } })
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getTechControlStatement', id)
      }
      return isResult
    },
  }
}
